import { Modal, ModalProps } from "react-bootstrap";
import { useEffect } from "react";

interface GroupTooManyPeopleModalProps extends ModalProps {
  onHide: () => void;
  foundCount: number;
  maxCount?: number;
  autoHideMs?: number;
}

const GroupTooManyPeopleModal = ({
  onHide,
  foundCount,
  maxCount = 6,
  autoHideMs = 4000,
  ...props
}: GroupTooManyPeopleModalProps) => {
  useEffect(() => {
    if (!props.show) return;
    const timer = window.setTimeout(() => {
      onHide();
    }, autoHideMs);
    return () => window.clearTimeout(timer);
  }, [props.show, autoHideMs, onHide]);

  return (
    <Modal
      {...props}
      onHide={onHide}
      backdrop="static"
      backdropClassName="confirmationModalBackdrop"
      className="mainMenuModal confirmationModal groupPersonCountMismatchModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody groupPersonCountMismatchBody">
          <div className="confirmationModalTitle groupPersonCountMismatchTitle">
            Too many people in photo
          </div>
          <p className="groupPersonCountMismatchMessage">
            We found <strong>{foundCount}</strong> persons in your photo.
            Please make sure your photo has no more than <strong>{maxCount}</strong> persons.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GroupTooManyPeopleModal;
